import { Producto } from './producto';

export class PlanAcumulativoDetalle{    
    public constructor(
        public id: String = "",
        public secuencial: number = 0,
        public detalle: String = "",
        public cantidad: number = 0,
        public precio_unitario: number = 0,
        public desc_valor: number = 0,
        public subtotal: number = 0,
        public iva: number = 0,
        public porct_iva: number = 0,
        public total: number = 0,
        public producto_id: String = "",
        public cantidad_stock: number = 0,
        public status:String = "",

        public empresa_id: String = "",
        public sucursal_id: String = "",
        public plan_id: String = "",
        public usuario_id:String = null,

        public producto: Producto = new Producto()
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/plan-acumulativo-detalle.ts